import React from "react";
import AppRouter from "./router/AppRouter";
import "../src/styles/responsive.css";
import "../src/App.css"

function App() {
  return (
    <div className="container">
      <AppRouter />
    </div>
  );
}

export default App;
